import {
    Grid2
} from '@mui/material';
import { getActualStatus } from '../../_helpers/auction.helper';
import { AuctioncatalogueItemUserBids } from './components/auction-catalogueItemBids';
import { CatalogueItemStatusCard } from './components/auction-catalogueItemStatusCard';
import { AuctionCatalogueItemView } from './components/auction-catalogueItemView';
import { AuctionCatalogueList } from './components/auction-catalogueList';
import { AuctionMessages } from './components/auction-messages';
import { useAuctionUserAdmin } from '../../_hubs/auctionUserAdmin.hub';

export function AuctionMonitorIndex(params: {
    auction: any,
    catalogueItem: any,
    catalogueItemLoading: boolean
}) {

    const { onlineUsers } = useAuctionUserAdmin();

    return (
        <>
            <Grid2 size={{ xs: 12, md: 4 }}>
                <Grid2 container spacing={1}>

                    <Grid2 size={{ xs: 12 }}>
                        <AuctionCatalogueList auction={params.auction} catalogueItem={params.catalogueItem} actualAuctionStatusId={getActualStatus(params.auction, params.catalogueItem)} />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <AuctionMessages catalogueId={params.catalogueItem?.catalogueId} />
                    </Grid2>

                </Grid2>
            </Grid2>

            <Grid2 size={{ xs: 12, md: 8 }}>
                <Grid2 container spacing={1}>

                    <Grid2 size={{ xs: 12 }}>
                        <CatalogueItemStatusCard catalogueItem={params.catalogueItem} actualAuctionStatusId={getActualStatus(params.auction, params.catalogueItem)} />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <AuctionCatalogueItemView catalogueItem={params.catalogueItem} catalogueItemLoading={params.catalogueItemLoading} />
                    </Grid2>

                    <Grid2 size={{ xs: 12 }}>
                        <AuctioncatalogueItemUserBids catalogueItem={params.catalogueItem} onlineUsers={onlineUsers} actualAuctionStatusId={getActualStatus(params.auction, params.catalogueItem)} />
                    </Grid2>

                </Grid2>
            </Grid2>
        </>
    );
}
